import { createContext } from 'react';

const defaultProperties = {
    base_url_api: '',
    fintoc_payment_enabled: '',
    fintoc_payment_key: '',
    fintoc_payment_text: '',
    fintoc_payment_logo: '',
    fintoc_create_session_endpoint: '',
    fintoc_comprobante_status_endpoint: '',
    fintoc_comprobante_pending_message: '',
    fintoc_comprobante_polling_interval: '',
    fintoc_comprobante_max_attempts: '',
    name_web_content: '',
    text_no_results: '',
    text_fetch_error: '',
    text_loading_boleta: '',
    text_fetch_no_id: '',
    text_alert_excel: '',
    text_alert_filled_field: '',
    titulo_pagos_realizados: '',
    descripcione_pagos_realizados: '',
    titulo_saldo_actual: '',
    descripcione_saldo_actual: '',
    titulo_service_status: '',
    titulo_reclamo: '',
    descripcione_service_status: '',
    titulo_compensation: '',
    titulo_reliquidation: '',
    descripcione_compensation: '',
    descripcione_compensation_public: '',
    descripcione_reliquidation_public: '',
    config_compensation_cartola_years: '',
    rel_12_2014: '',
    api_key_recaptcha: '',
    codigo_empresa: '',
    url_ws_empresa: '',
    estas_sin_luz_content_correo: '',
    reclamo_edelmag_content_correo: '',
    qnt_list_boletas: '',
    title_pdf_ticket: '',
    titulo_last_tickets: '',
    descripcione_last_tickets: '',
    titulo_last_tickets_public: '',
    descripcione_last_tickets_public: '',
    last_year_tickets_emission: '',
    text_error_last_year_tickets_emission: '',
    titulo_ingreso_solicitud: '',
    msg_verification_read_ingreso_solicitud: '',
    msg_cost_ingreso_solicitud: '',
    titulo_emision_certificado_deuda: '',
    titulo_emision_certificado_dotacion: '',
    descripcione_emision_certificado_deuda: '',
    descripcione_emision_certificado_dotacion: '',
    web_content_certificate_deuda: '',
    web_content_certificate_dotacion: '',
    title_response_letter_sms: '',
    title_subscription: '',
    title_alta_subscription: '',
    title_modification_subscription: '',
    title_anulation_subscription: '',
    description_alta_subscription: '',
    description_modification_anulation_subscription: '',
    web_content_alta_subscription: '',
    web_content_anulation_subscription: '',
    description_modification_pub: '',
    description_anulation_pub: '',
    web_content_modification_subscription_email: '',
    web_content_note_subscription_pub: '',
    web_content_info_update_of_contact_information_no_aux_text: '',
    title_forms_electrodependent: '',
    description_forms_electrodependent: '',
    web_content_terms_electrodependent: '',
    description_forms_eleccion_medio_informarse: '',
    description_forms_tipos_documentacion: '',
    description_forms_data_certificate_doctor: '',
    correo_content_name_alta_subscription: '',
    pagination_confirmation_alta_subscription: '',
    title_confirmation_alta_subscription: '',
    title_confirmation_modificacion_subscription: '',
    pagination_confirmation_modificacion_subscription: '',
    correo_content_name_modificacion_subscription: '',
    tamano_maximo_de_archivo_MB: '',
    tipo_de_archivo: '',
    web_content_return_fetch_electrodependent: '',
    liferay_base_url: '',
    title_convenio_vulnerable: '',
    subtitle_convenio_vulnerable: '',
    title_section_client: '',
    title_section_solicitante_convenio_vulnerable: '',
    web_content_terms_conditions_convenio_vulnerable: '',
    title_section_vulnerabilidad_convenio_vulnerable: '',
    title_section_terminos_convenio_vulnerable: '',
    title_datos_personales: '',
    title_section_datos_personales_1: '',
    title_section_datos_personales_2: '',
    title_section_datos_personales_3: '',
    title_cambio_contrasena: '',
    title_section_cambio_contrasena_1: '',
    title_section_cambio_contrasena_2: '',
    condition_cambio_contrasena_1: '',
    condition_cambio_contrasena_2: '',
    condition_cambio_contrasena_3: '',
    condition_cambio_contrasena_4: '',
    web_content_return_success_subsidy: '',
    web_content_return_fail_subsidy: '',
    cantidad_cuotas_mensuales: '',
    title_detalle_interacciones_report: '',
    description_detalle_interacciones_report: '',
    section_1_tables_reports: '',
    section_2_tables_reports: '',
    canal_calcula_tu_cuota: '',
    servicio_description_comprobante_de_pago: '',
    titlle_correo_webContent_comprobante_de_pago: '',
    error_comprobante_de_pago: '',
    title_page_oficina_virtual: '',
    title_norma_tecnica: '',
    title_reconversion_energetica: '',
    descripcione_formulario_contingencia: '',

    // AMI – Lista de medidores
    ami_page_title: '',
    ami_column_serial: '',
    ami_column_address: '',
    ami_column_valid_from: '',
    ami_column_valid_to: '',
    ami_loading_meters: '',
    ami_error_meters: '',
    ami_no_meters: '',

    // AMI – Detalle del medidor (textos generales)
    ami_detail_title: '',
    ami_detail_back_button: '',
    ami_detail_loading: '',
    ami_detail_error: '',
    ami_detail_date_range_title: '',
    ami_detail_date_range_help: '',
    ami_detail_date_from_label: '',
    ami_detail_date_to_label: '',
    ami_detail_slider_left_label: '',
    ami_detail_slider_right_label: '',
    ami_detail_days_selected_singular: '',
    ami_detail_days_selected_plural: '',
    ami_detail_chart_title: '',
    ami_detail_chart_hint_prefix: '',
    ami_detail_chart_hint_suffix: '',

    // AMI – Configuración de pestañas
    ami_detail_tabs_total: '',

    // Tab 1
    ami_detail_tab_1_key: '',
    ami_detail_tab_1_label: '',
    ami_detail_tab_1_metric: '',
    ami_detail_tab_1_tooltip: '',
    ami_detail_tab_1_cimcodes: '',

    // Tab 2
    ami_detail_tab_2_key: '',
    ami_detail_tab_2_label: '',
    ami_detail_tab_2_metric: '',
    ami_detail_tab_2_tooltip: '',
    ami_detail_tab_2_cimcodes: '',

    // Tab 3
    ami_detail_tab_3_key: '',
    ami_detail_tab_3_label: '',
    ami_detail_tab_3_metric: '',
    ami_detail_tab_3_tooltip: '',
    ami_detail_tab_3_cimcodes: '',

    // Tab 4
    ami_detail_tab_4_key: '',
    ami_detail_tab_4_label: '',
    ami_detail_tab_4_metric: '',
    ami_detail_tab_4_tooltip: '',
    ami_detail_tab_4_cimcodes: '',

    // (Opcionales, por si negocio algún día quiere más de 4 pestañas)
    ami_detail_tab_5_key: '',
    ami_detail_tab_5_label: '',
    ami_detail_tab_5_metric: '',
    ami_detail_tab_5_tooltip: '',
    ami_detail_tab_5_cimcodes: '',

    ami_detail_tab_6_key: '',
    ami_detail_tab_6_label: '',
    ami_detail_tab_6_metric: '',
    ami_detail_tab_6_tooltip: '',
    ami_detail_tab_6_cimcodes: '',
};

export const ApplicationPropertiesContext = createContext(defaultProperties);

const ApplicationContextProvider = ({ children, properties }) => (
    <ApplicationPropertiesContext.Provider value={properties}>
        {children}
    </ApplicationPropertiesContext.Provider>
);

export default ApplicationContextProvider;
